export type ImageType = 'profile' | 'background' | 'featured';

const STORAGE_PREFIX = 'storage://';

export function isStorageKey(value: string | undefined | null): boolean {
  if (!value) return false;
  return value.startsWith(STORAGE_PREFIX);
}

export function isDataUrl(value: string | undefined | null): boolean {
  if (!value) return false;
  return value.startsWith('data:');
}

export function isExternalUrl(value: string | undefined | null): boolean {
  if (!value) return false;
  return value.startsWith('http://') || value.startsWith('https://');
}

export function getS3Key(storageKey: string): string {
  if (!isStorageKey(storageKey)) {
    throw new Error('Invalid storage key format');
  }
  return storageKey.slice(STORAGE_PREFIX.length);
}

export function createStorageKey(s3Key: string): string {
  return STORAGE_PREFIX + s3Key;
}

export function generateS3Key(userId: string, imageType: ImageType, filename: string): string {
  const ext = filename.split('.').pop()?.toLowerCase() || 'jpg';
  const uuid = crypto.randomUUID();

  return `users/${userId}/images/${imageType}/${uuid}.${ext}`;
}


export function isValidImageType(type: string): type is ImageType {
  return type === 'profile' || type === 'background' || type === 'featured';
}

export function getUserIdFromKey(s3Key: string): string | null {
  const match = s3Key.match(/^users\/([^/]+)\/images\//);
  return match ? match[1] : null;
}

export function getImageTypeFromKey(s3Key: string): ImageType | null {
  const match = s3Key.match(/^users\/[^/]+\/images\/([^/]+)\//);
  if (!match) return null;

  const type = match[1];
  return isValidImageType(type) ? type : null;
}
